const MAX_DIMENSION_STEPS = [800, 600, 400, 300];
const QUALITY_STEPS = [0.7, 0.5, 0.35, 0.2];
const TARGET_MAX_BYTES = 250000; // ~250KB per image, keeps each message document well under Firestore's 1MiB document limit

export class ImageTooLargeError extends Error {}

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Could not read that image file.'));
    };
    img.src = url;
  });
}

function canvasToBase64(img, maxDimension, quality) {
  const scale = Math.min(1, maxDimension / Math.max(img.width, img.height));
  const width = Math.round(img.width * scale);
  const height = Math.round(img.height * scale);

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  canvas.getContext('2d').drawImage(img, 0, 0, width, height);

  return canvas.toDataURL('image/jpeg', quality);
}

function base64SizeInBytes(base64String) {
  const raw = base64String.slice(base64String.indexOf(',') + 1);
  const padding = raw.endsWith('==') ? 2 : raw.endsWith('=') ? 1 : 0;
  return (raw.length * 3) / 4 - padding;
}

export async function compressImageToBase64(file) {
  if (!file.type.startsWith('image/')) {
    throw new Error('Only image files can be sent.');
  }

  const img = await loadImage(file);

  for (const maxDimension of MAX_DIMENSION_STEPS) {
    for (const quality of QUALITY_STEPS) {
      const base64 = canvasToBase64(img, maxDimension, quality);
      if (base64SizeInBytes(base64) <= TARGET_MAX_BYTES) {
        return base64;
      }
    }
  }

  throw new ImageTooLargeError(
    'This image is too large to send, even after compression. Please try a smaller image.'
  );
}